import { FC } from 'react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay?: string;
  index?: number;
}

const FeatureCard: FC<FeatureCardProps> = ({
  icon,
  title,
  description,
  delay,
  index,
}) => {
  return (
    <div
      className='bg-card border border-border rounded-lg p-8 transition-all duration-300 h-full flex flex-col
        hover:shadow-md hover:border-primary/20 hover:translate-y-[-5px] animate-fadeInUp'
      style={{ animationDelay: delay || '0s' }}>
      <div className='inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-6 transition-all duration-300 hover:scale-105 hover:bg-primary/15'>
        {icon}
      </div>

      <h3 className='text-xl font-semibold mb-3 text-card-foreground'>{title}</h3>
      <p className='text-muted-foreground text-base leading-relaxed flex-grow'>
        {description}
      </p>

      {/* Subtle accent decoration */}
      <div className='w-12 h-0.5 bg-primary/10 rounded-full mt-6 transition-all duration-300 group-hover:w-16 group-hover:bg-primary/20'></div>
    </div>
  );
};

export default FeatureCard;
